import { useContext } from 'react';
import LessonContext, { LessonContextProps } from '../context/LessonContext';

const useLessonContext = (): LessonContextProps => useContext(LessonContext);

export default useLessonContext;
